import React from 'react';
import { Icon } from 'antd';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};
export const successUpdateProfileFilters = {
  ...optionsDefault,
  title: 'Изменения успешно сохранены!',
  content: `Изменения успешно внесены в настройки профиля`,
};
